<nb-layout>

  <nb-layout-column>
       <app-painel></app-painel>
  </nb-layout-column>

</nb-layout>
